export class RequestError extends Error {
    public details: unknown;

    constructor(message: string, details?: unknown) {
        super(message);
        this.name = 'RequestError';
        this.details = details;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RequestError);
        }
    }
}
